import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/shared/material/material.module';

export type DeleteCallbackLocationConfirmData = {
  name: string;
};

@Component({
  selector: 'app-delete-callback-location-confirm-dialog',
  standalone: true,
  imports: [MaterialModule, MatDialogModule],
  templateUrl: './delete-callback-location-confirm-dialog.component.html',
})
export class DeleteCallbackLocationConfirmDialogComponent {
  #dialogRef = inject(MatDialogRef<DeleteCallbackLocationConfirmDialogComponent, boolean>);
  data: DeleteCallbackLocationConfirmData = inject(MAT_DIALOG_DATA);

  onConfirm(): void {
    this.#dialogRef.close(true);
  }
}
